export default "__VITE_ASSET__DgykA0Mu__"